import React from 'react';
import { useScrollReveal } from '../hooks/useScrollReveal';
import { Card, CardContent } from './ui/card';
import { Syringe, Wind, Activity, Droplet, Zap, Pill } from 'lucide-react';

const SKILLS = [
  { icon: Syringe, name: 'Central Venous Catheterization', description: 'Expert placement and management' },
  { icon: Wind, name: 'Intubation', description: 'Advanced airway management' },
  { icon: Activity, name: 'Ventilator Management', description: 'Critical respiratory support' },
  { icon: Droplet, name: 'Arterial Line Insertion', description: 'Hemodynamic monitoring' },
  { icon: Droplet, name: 'Intercostal Drain Insertion', description: 'Pleural space management' },
  { icon: Syringe, name: 'Lumbar Puncture', description: 'Cerebrospinal fluid analysis' },
  { icon: Syringe, name: 'Bone Marrow Aspiration & Biopsy', description: 'Hematological assessment' },
  { icon: Zap, name: 'Emergency Procedures', description: 'Life-saving interventions' },
  { icon: Pill, name: 'Critical Care Protocols', description: 'Evidence-based management' }
];

const SkillCard = ({ skill, index }) => {
  const Icon = skill.icon;
  return (
    <Card
      className="card-hover scroll-reveal-scale transition-all duration-500"
      style={{ borderColor: '#e8f5e9', animationDelay: `${0.2 + index * 0.08}s` }}
      onMouseEnter={(e) => e.currentTarget.style.borderColor = 'var(--medical-accent)'}
      onMouseLeave={(e) => e.currentTarget.style.borderColor = '#e8f5e9'}
    >
      <CardContent className="pt-6">
        <div className="flex items-start gap-4">
          <div className="flex-shrink-0 w-12 h-12 rounded-lg flex items-center justify-center" style={{ backgroundColor: '#e8f5e9' }}>
            <Icon style={{ color: 'var(--medical-primary)' }} size={24} />
          </div>
          <div>
            <h3 className="text-lg font-semibold text-slate-900 mb-1">{skill.name}</h3>
            <p className="text-sm text-slate-600">{skill.description}</p>
          </div>
        </div>
      </CardContent>
    </Card>
  );
};

const SkillsSection = () => {
  const sectionRef = useScrollReveal();

  return (
    <section id="skills" className="py-20 px-4 bg-white" ref={sectionRef}>
      <div className="container mx-auto max-w-6xl">
        <h2 className="text-3xl md:text-4xl font-bold text-slate-900 mb-4 text-center scroll-reveal">
          Procedural Skills
        </h2>
        <div className="w-20 h-1 mx-auto mb-12 scroll-reveal" style={{ backgroundColor: 'var(--medical-primary)', animationDelay: '0.1s' }}></div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 gap-6">
          {SKILLS.map((skill, index) => (
            <SkillCard key={skill.name} skill={skill} index={index} />
          ))}
        </div>
      </div>
    </section>
  );
};

export default SkillsSection;
